import React, { useState } from "react";
import { Field, Form } from "react-final-form";
import arrayMutators from "final-form-arrays";
import { Button, Modal, ModalHeader, ModalBody } from "reactstrap";
import { TextInput } from "../../../../components/inputs/final_form/TextInput";
import { LoadingButton } from "../../../../components/LoadingButton";
import { DetailedErrorAlert } from "../../../../components/DetailedErrorAlert";
import { api, extractErrorMessage } from "../../../../util/api";
import { snakifyKeys } from "../../../../util/helpers";
import { InvalidMemberIdForm } from "./InvalidMemberIdForm";

export const AddInvalidMemberIdModal = ({ onAdd, ...buttonProps }) => {
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  const toggleModal = () => setOpen((x) => !x);

  const handleCreate = async (values) => {
    setError(null);
    try {
      const res = await api.post("/admin/invalid_member_ids", { invalid_member_id: snakifyKeys(values) });

      if (onAdd) {
        // Inserted with no errors
        onAdd(`Successfully inserted the invalid member id "${values.invalidMemberId}".`, []);
      }

      setOpen(false);
    } catch (err) {
      setError(err);
    }
  };

  return (
    <>
      <Button {...buttonProps} onClick={toggleModal}>
        Add Invalid Member Id
      </Button>

      <Modal isOpen={open} toggle={toggleModal}>
        <ModalHeader toggle={toggleModal}>Add Invalid MemberId</ModalHeader>
        <ModalBody>
          <DetailedErrorAlert error={error} />
          <Form
            onSubmit={handleCreate}
            mutators={{
              ...arrayMutators,
            }}
            keepDirtyOnReinitialize={true}
          >
            {(props) => <InvalidMemberIdForm {...props} />}
          </Form>
        </ModalBody>
      </Modal>
    </>
  );
};
